import Swiper, {Navigation, Pagination} from "swiper";

export const setupSlider = () => {
    const sliderWrapper = document.querySelector('.recent-post__wrapper');
    if (!sliderWrapper) {
        return;
    }
    Swiper.use([Navigation, Pagination]);

    new Swiper(sliderWrapper.querySelector('.swiper-container'), {

        slidesPerView: 1,
        spaceBetween: 10,

        breakpoints: {
            1: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            680: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1000: {
                slidesPerView: 3,
                spaceBetween: 30
            }
        },

        navigation: {
            nextEl: sliderWrapper.querySelector('.swiper-button-next'),
            prevEl: sliderWrapper.querySelector('.swiper-button-prev'),
        },

        pagination: {
            el: sliderWrapper.querySelector('.swiper-pagination'),
            type: 'bullets',
        },

        loop: false,

    });
}